import { MaintenanceBannerTranslations } from "./types";

export const deMaintenanceBannerTranslations: MaintenanceBannerTranslations = {
    upcoming: (starts, ends) =>
        `Geplante Wartung am ${starts} bis ${ends}. Während dieser Zeit ist keine Anmeldung möglich.`,
    active: (ends) =>
        `Die Wartung läuft gerade. Eine Anmeldung ist erst ab ${ends} wieder möglich.`,
    dismiss: "Schließen",
};
